<template>
    <!--    <p v-show="loading">Loading..</p>-->

    <!--    <p v-if="result">result: {{ result }}</p>-->

    <div v-if="athleticsItems != null" class="news__section-list">
        <article v-for="(item, index) in athleticsItems.data.newsEntries"
                 :class="( showFirst === true && index === 0 ? 'first' : 'list' )"
                 class="news__article">
            <a v-for="img in item.featuredImage" v-if="index === 0" :href="item.url" class="news__article-image"
               target="_blank">
                <div class="article__image__inner">
                <img :alt="img.title" :src="img.teaserImgOpt.src" :srcset="img.teaserImgOpt.srcset"
                     class="article__image"/>
                </div>
            </a>
            <!--                    {{ item.generalNewsCategories.map(entry => entry.title).join(', ') }}-->
            <p class="news__article-categories">
                <a v-for="crumb in item.generalNewsCategories" v-if="item.generalNewsCategories !== ''"
                   :href="'https://athletics.andover.edu/news?f=' + crumb.title"
                   class="news__article-category">{{ crumb.title }}</a>
            </p>
            <a :href="item.url" class="news__article-title" target="_blank">{{ item.title }}<i
                class="fa-regular fa-arrow-up-right-from-square external-link"></i></a>
            <p v-if="index === 0 && item.articleSubtitle !== '' || showFirst === false" class="news__article-body">
                {{
                    item.articleSubtitle
                }}</p>

        </article>
    </div>
    <!--    <p v-else-if="error">error: {{ error }}</p>-->
</template>
<script setup>
import { ref } from 'vue'

// variables
const athleticsFeedURL = import.meta.env.VITE_ATHLETICS_FEED_API_TARGET
const athleticsAuth = import.meta.env.VITE_ATHLETICS_FEED_API_AUTH
const athleticsItems = ref(null)

const props = defineProps({
    athleticsArray: {
        type: Array,
        required: true,
    },
    entryNumber: Number,
    showFirst: Boolean,
})

const variables = {
    entryNumber: props.athleticsArray[0].entryNumber
}
console.log(variables)
const showFirst = props.athleticsArray[0].showFirst
console.log(showFirst)
// authentication
const authentication = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + athleticsAuth
}
const headers = new Headers(authentication)

// fetch
fetch(athleticsFeedURL, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
        query: `query NewsEntries($entryNumber: Int!) {
              newsEntries(limit: $entryNumber, orderBy: "postDate DESC") {
                ... on news_Entry {
                  id
                  url
                  title
                  articleSubtitle @stripTags
                  postDate
                  featuredImage {
                    ... on images_Asset {
                      id
                      teaserImgOpt {
                        src
                        srcset
                      }
                    }
                    title
                  }
                  generalNewsCategories {
                    title
                  }
                }
              }
          }
        `,
        variables
    }),
})
    .then(response => response.json())
    .then(data => athleticsItems.value = data)
    .then(json => console.log(json))
</script>
